import React from "react";

import { normalizeEmoji } from "./reactionEmoji";

export default function MessageReactionBadge({ emoji, onRemove }) {
	const display = normalizeEmoji(emoji);
	if (!display) return null;

	const handleClick = (event) => {
		event.stopPropagation();
		if (onRemove) onRemove();
	};

	const handleKeyDown = (event) => {
		if (!onRemove) return;
		if (event.key === "Enter" || event.key === " ") {
			event.preventDefault();
			event.stopPropagation();
			onRemove();
		}
	};

	return (
		<span
			className={`tailwick-message-reaction${onRemove ? " tailwick-message-reaction--removable" : ""}`}
			title={onRemove ? `Remover ${display}` : display}
			onClick={onRemove ? handleClick : undefined}
			onKeyDown={onRemove ? handleKeyDown : undefined}
			role={onRemove ? "button" : undefined}
			tabIndex={onRemove ? 0 : undefined}
		>
			<span className="tailwick-message-reaction__glyph" aria-hidden>
				{display}
			</span>
		</span>
	);
}
